import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import * as appConfig from "appConfig";
import styles from "./MixStage.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Introduction.messages";
import { useIntl } from "react-intl";

type MixStageModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const MixStageModal: React.FC<MixStageModalProps> = (props) => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  return (
    <ui.Modal {...props}>
      <div className={styles.modal}>
        <div className={styles.titleContainer}>{formatMessage(messages.slide5Modal2Title)}</div>
        <img
          style={{ height: "auto", width: "100%" }}
          className={styles.speakersSetup}
          src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/introduction/slide5/mix-stage.jpg`}
          alt="feature-comparison"
        />
        <div className={styles.description}>{formatMessage(messages.slide5Modal2Description)}</div>
      </div>
    </ui.Modal>
  );
};
